import React from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { Box, Dialog, Typography, DialogContent, Button, Link } from '@availity/element';

import DynamicField from '../../../Common/components/DynamicField';

import IncidentStore from '../../../Common/stores/IncidentStore';
import ProviderStore from '../../../Common/stores/ProviderStore';

const ErrorModal = ({ incidentStore, isOpen, providerStore }) => {
  const navigate = useNavigate();
  const { retryCount } = incidentStore;

  const handleClick = (event) => {
    const { buttonName } = event.currentTarget.dataset;
    if (buttonName) {
      incidentStore.setOpenErrorModal();
      if (buttonName === 'OK') {
        providerStore.resetStore();
        navigate('/', { replace: true });
        incidentStore.handleChangeIncidentStore('retryCount', 0);
      }
    }
  };

  return (
    <Dialog
      open={isOpen}
      id="confirmation-modal"
      scroll="body"
      disableEscapeKeyDown
      disableBackdrop
      Click
      closeButton={false}
      sx={{
        '.css-1uv3rse-MuiPaper-root-MuiDialog-paper': {
          maxWidth: '45rem',
        },
      }}
    >
      <DialogContent id="confirmation-modal-body" sx={{ padding: '1.875rem' }}>
        <DynamicField fieldName="roiErrorContent">
          <Box
            id="confirmation-modal-content-box"
            sx={{ mt: '1.25rem', mb: '1.25rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          >
            <Typography
              id="confirmation-text"
              variant="h5"
              sx={{ fontWeight: 'bold', textAlign: 'center', margin: '1.25rem' }}
            >
              The Incident Report that was posted has failed to send.
            </Typography>
            {retryCount >= 3 && (
              <Typography
                id="try-again-or-hit-submit-again"
                variant="h6"
                sx={{ textAlign: 'center', margin: '1.25rem' }}
              >
                Please try again sometime later.
              </Typography>
            )}
            <Button
              id="create-another-incident"
              data-button-name={retryCount < 3 ? 'Hit Submit Again' : 'OK'}
              onClick={(e) => {
                e.preventDefault();
                handleClick(e);
              }}
              variant="contained"
              color="secondary"
            >
              {retryCount > 0 && retryCount < 3 ? 'Hit Submit Again' : 'OK'}
            </Button>
          </Box>
        </DynamicField>
        <DynamicField fieldName="rmirErrorContent">
          <Box
            id="rmir-confirmation-modal-content-box"
            sx={{ mt: '1.25rem', mb: '1.25rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          >
            <Typography
              id="rmir-confirmation-text"
              variant="h5"
              sx={{ fontWeight: 'bold', textAlign: 'center', margin: '1.25rem' }}
            >
              {retryCount > 0 && retryCount < 3
                ? 'Something went wrong.'
                : 'The Incident Report that was posted has failed to send.'}
            </Typography>
            {retryCount > 0 && retryCount < 3 ? (
              <Typography
                id="rmir-try-again-or-hit-submit-again-less-than-3-try"
                variant="h6"
                sx={{ textAlign: 'center', margin: '1.25rem' }}
              >
                Please Try Again...
              </Typography>
            ) : (
              <Typography
                id="rmir-try-again-or-hit-submit-again-more-than-3-try"
                variant="h6"
                sx={{ textAlign: 'center', margin: '1.25rem' }}
              >
                Please send form via email to{' '}
                <DynamicField fieldName="mailForSimply">
                  <Link id="mail-to-simply" href="mailto:RiskManagement@simplyhealthcareplans.com">
                    RiskManagement@simplyhealthcareplans.com
                  </Link>
                </DynamicField>
                <DynamicField fieldName="mailForClear">
                  <Link id="mail-to-clear" href="mailto:RiskManagement@simplyhealthcareplans.com">
                    RiskManagement@simplyhealthcareplans.com
                  </Link>
                </DynamicField>
              </Typography>
            )}
            <Button
              id="create-another-incident"
              data-button-name={retryCount > 0 && retryCount < 3 ? 'Hit Submit Again' : 'OK'}
              onClick={(e) => {
                e.preventDefault();
                handleClick(e);
              }}
              variant="contained"
              color="secondary"
            >
              {retryCount > 0 && retryCount < 3 ? 'Hit Submit Again' : 'OK'}
            </Button>
          </Box>
        </DynamicField>
      </DialogContent>
    </Dialog>
  );
};

ErrorModal.propTypes = {
  isOpen: PropTypes.bool,
  incidentStore: PropTypes.oneOf([IncidentStore]).isRequired,
  providerStore: PropTypes.oneOf([ProviderStore]).isRequired,
};

export default inject('incidentStore', 'providerStore')(observer(ErrorModal));
